import axios from "@/utils/axios"
import moment from 'moment'
import { DATE_FORMAT, DEFAULT_LIMIT } from "@/utils/config"
import { get_all_taxonomies, get_available_taxonomy } from "@/utils/util"

export function getEvents(total = DEFAULT_LIMIT) {
  return axios.get('/events/', {
    params: {
      range_start: 0,
      range_total: total,
      start_date: moment().format(DATE_FORMAT),
      taxonomy: get_all_taxonomies()
    }
  });
}

export function getFilteredEvents( start = '', end = '', filter = [], page = 1, limit = DEFAULT_LIMIT ) {
  let params = {
    range_start: (page - 1) * limit,
    range_total: limit,
    taxonomy: get_all_taxonomies()
  };

  if (page == 0) {
    params = {
      taxonomy: get_all_taxonomies()
    };
  }

  if (start) {
    params.start_date = start;
  } else {
    params.start_date = moment().format(DATE_FORMAT);
  }

  if (end) {
    params.end_date = end;
  }

  if (filter.length) {
    params.category = filter;
  }

  return axios.get('/events/', {
    params
  });
}

export function search(keywords, page =1, limit = DEFAULT_LIMIT) {
  return axios.get('/events/', {
    params: {
      range_start: (page - 1) * limit,
      range_total: limit,
      s: keywords,
      start_date: moment().format(DATE_FORMAT),
      taxonomy: get_all_taxonomies()
    }
  });
}

export function getCategories() {
  return axios.get('/categories/', {
    params: {
      taxonomy: get_available_taxonomy()
    }
  });
}